// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: H39H8FW52Adf

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicCollapsableWrapper.module.css"; // plasmic-import: H39H8FW52Adf/css

import ArrowIosRightsvgIcon from "./icons/PlasmicIcon__ArrowIosRightsvg"; // plasmic-import: 5TngLItwC/icon

createPlasmicElementProxy;

export type PlasmicCollapsableWrapper__VariantMembers = {
  isCollapsed: "isCollapsed";
  isInactive: "isInactive";
  behaviour: "hugging" | "stretching" | "keepingWidth";
};
export type PlasmicCollapsableWrapper__VariantsArgs = {
  isCollapsed?: SingleBooleanChoiceArg<"isCollapsed">;
  isInactive?: SingleBooleanChoiceArg<"isInactive">;
  behaviour?: SingleChoiceArg<"hugging" | "stretching" | "keepingWidth">;
};
type VariantPropType = keyof PlasmicCollapsableWrapper__VariantsArgs;
export const PlasmicCollapsableWrapper__VariantProps =
  new Array<VariantPropType>("isCollapsed", "isInactive", "behaviour");

export type PlasmicCollapsableWrapper__ArgsType = {
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicCollapsableWrapper__ArgsType;
export const PlasmicCollapsableWrapper__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicCollapsableWrapper__OverridesType = {
  root?: p.Flex<"div">;
  button?: p.Flex<"button">;
  svg?: p.Flex<"svg">;
  freeBox?: p.Flex<"div">;
};

export interface DefaultCollapsableWrapperProps {
  children?: React.ReactNode;
  isCollapsed?: SingleBooleanChoiceArg<"isCollapsed">;
  isInactive?: SingleBooleanChoiceArg<"isInactive">;
  behaviour?: SingleChoiceArg<"hugging" | "stretching" | "keepingWidth">;
  className?: string;
}

const $$ = {};

function PlasmicCollapsableWrapper__RenderFunc(props: {
  variants: PlasmicCollapsableWrapper__VariantsArgs;
  args: PlasmicCollapsableWrapper__ArgsType;
  overrides: PlasmicCollapsableWrapper__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isCollapsed",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isCollapsed
      },
      {
        path: "isInactive",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isInactive
      },
      {
        path: "behaviour",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.behaviour
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        { [sty.rootisInactive]: hasVariant($state, "isInactive", "isInactive") }
      )}
    >
      <button
        data-plasmic-name={"button"}
        data-plasmic-override={overrides.button}
        className={classNames(projectcss.all, projectcss.button, sty.button, {
          [sty.buttonglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.buttonisCollapsed]: hasVariant(
            $state,
            "isCollapsed",
            "isCollapsed"
          ),
          [sty.buttonisInactive]: hasVariant($state, "isInactive", "isInactive")
        })}
      >
        <ArrowIosRightsvgIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames(projectcss.all, sty.svg, {
            [sty.svgglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.svgglobal_theme_light]: hasVariant(
              globalVariants,
              "theme",
              "light"
            ),
            [sty.svgisCollapsed]: hasVariant(
              $state,
              "isCollapsed",
              "isCollapsed"
            )
          })}
          role={"img"}
        />
      </button>
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxbehaviour_keepingWidth]: hasVariant(
            $state,
            "behaviour",
            "keepingWidth"
          ),
          [sty.freeBoxbehaviour_keepingWidth_isCollapsed]:
            hasVariant($state, "isCollapsed", "isCollapsed") &&
            hasVariant($state, "behaviour", "keepingWidth"),
          [sty.freeBoxbehaviour_stretching]: hasVariant(
            $state,
            "behaviour",
            "stretching"
          ),
          [sty.freeBoxisCollapsed]: hasVariant(
            $state,
            "isCollapsed",
            "isCollapsed"
          )
        })}
      >
        {p.renderPlasmicSlot({
          defaultContents: null,
          value: args.children
        })}
      </div>
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "button", "svg", "freeBox"],
  button: ["button", "svg"],
  svg: ["svg"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  button: "button";
  svg: "svg";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCollapsableWrapper__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCollapsableWrapper__VariantsArgs;
    args?: PlasmicCollapsableWrapper__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicCollapsableWrapper__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicCollapsableWrapper__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCollapsableWrapper__ArgProps,
          internalVariantPropNames: PlasmicCollapsableWrapper__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCollapsableWrapper__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCollapsableWrapper";
  } else {
    func.displayName = `PlasmicCollapsableWrapper.${nodeName}`;
  }
  return func;
}

export const PlasmicCollapsableWrapper = Object.assign(
  // Top-level PlasmicCollapsableWrapper renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    button: makeNodeComponent("button"),
    svg: makeNodeComponent("svg"),
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicCollapsableWrapper
    internalVariantProps: PlasmicCollapsableWrapper__VariantProps,
    internalArgProps: PlasmicCollapsableWrapper__ArgProps
  }
);

export default PlasmicCollapsableWrapper;
/* prettier-ignore-end */
